import React from "react";

const Loader = () => {
  return (
    <div className="animate-pulse grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-16 ">
      <div className="bg-gray-200 rounded-lg shadow-xl transition-all duration-30  ">
        <div className="bg-gray-100 py-40 px-40 "></div>
      </div>
      <div className="bg-gray-200 rounded-lg shadow-xl transition-all duration-30">
        <div className="bg-gray-100 py-40 px-40 "></div>
      </div>
      <div className="bg-gray-200 rounded-lg shadow-xl transition-all duration-30 ">
        <div className="bg-gray-100 py-40 px-40 "></div>
      </div>
      <div className="bg-gray-200 rounded-lg shadow-xl transition-all duration-30 ">
        <div className="bg-gray-100 py-40 px-40 "></div>
      </div>
    </div>
  );
};

export default Loader;
